import { makeResetStyles } from '@fluentui/react-components';

export const useObjectSelectionStyles = makeResetStyles({
  '& .image-wrapper': {
    position: 'relative',
    width: '100%',
    '& img': {
      width: '100%',
      objectFit: 'contain',
    },
    '& div': {
      width: '100%',
    },
    '& .original-image': {
    },
    '& .cover-original-image': {
      backgroundImage: 'linear-gradient(90deg, rgba(70, 79, 235, 0.75) 0%, rgba(180, 124, 248, 0.75) 100%)',
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
    },
    '& .loading-segmentations-image': {
      backgroundImage: 'linear-gradient(90deg, rgba(70, 79, 235, 0.75) 0%, rgba(180, 124, 248, 0.75) 100%)',
      animationDuration: '3s',
      animationIterationCount: 'infinite',
      animationTimingFunction: 'linear',
      animationName: [{
        from: { backgroundPosition: '0%' }, // The whole background is 800% and we use only the 0-7 range
        to: { backgroundPosition: '100%' },
      }],
      position: 'absolute',
      backgroundSize: '400%',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
    },
    '& .selected-image': {
      position: 'absolute',
      top: 0,
      left: 0,
    },
    '& .border-image': {
      position: 'absolute',
      top: 0,
      left: 0,
    },
    '& .highlighted-image': {
      position: 'absolute',
      top: 0,
      left: 0,
    },
  },
});

